var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.2486C22 16.0198 22 17.9054 20.8284 19.077C19.6569 20.2486 17.7712 20.2486 14 20.2486H10C6.22876 20.2486 4.34315 20.2486 3.17157 19.077C2 17.9054 2 16.0198 2 12.2486C2 8.47733 2 6.59171 3.17157 5.42014C4.34315 4.24857 6.22876 4.24857 10 4.24857H14C17.7712 4.24857 19.6569 4.24857 20.8284 5.42014C21.4816 6.07332 21.7706 6.94845 21.8985 8.24857",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.24857L15.8411 10.0476C14.0045 11.5782 13.0861 12.3434 12 12.3434C11.3507 12.3434 10.7614 12.07 10 11.523M6 8.24857L6.9 8.99857L7.8 9.74857",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/Letter.6ec54b5a32e0b5b398e1c68a7e2941ed.svg";
export { ForwardRef as ReactComponent };